export enum ValidatedByCountryFields {
  STATE = 'State',
  TAX_ID = 'TaxID',
  ZIP_CODE = 'ZipCode',
  EMAIL_PIXELS = 'EMAIL_PIXELS',
}
